import { Button, ButtonVariants } from "@inno-ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "@inno-ui/icons";
import { useTranslation } from "react-i18next";

import { useGeneralStore } from "../../../../store/general/general-store";
import { Calendar } from "../../../calendar";
import MobileFooter from "../../mobile-footer/mobile-footer";
import styles from "./data.module.scss";

export function Date() {
  const { t } = useTranslation();
  const { onNext, onPrev } = useGeneralStore();

  return (
    <div className={styles.dateContainer}>
      <Calendar />
      <MobileFooter
        primaryButton={(
          <Button
            variant={ButtonVariants.Dark}
            label={t("next")}
            width="100%"
            trailingIcon={ChevronRightIcon}
            onClick={onNext}
          />
        )}
        secondaryButton={(
          <Button
            variant={ButtonVariants.Light}
            label={t("back")}
            width="100%"
            icon={ChevronLeftIcon}
            onClick={onPrev}
          />
        )}
      />
    </div>
  );
}
